export default __webpack_public_path__ + "static/media/mastercard.0d5a2f11.svg";